export const DONATION_CONTRACT =
  import.meta.env.VITE_DONATION_CONTRACT ||
  "0x2EC7ED26b7B1EA819D3B40f0482DBC5e48123c30";

export const BSC_CHAIN_ID = 56;
export const BSC_CHAIN_ID_HEX = "0x38";

export const BSC_EXPLORER = "https://bscscan.com";
export const BSC_RPC_URL = "https://bsc-dataseed.binance.org";

export function shortAddress(address?: string) {
  if (!address) return "";
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}
